import React from 'react';


export function Bangladesh(props) {
	return (
		<svg width="513" height="342" viewBox="0 0 513 342" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clip-path="url(#clip0_301_1579)">
				<path d="M0 -0.0078125H513V341.992H0V-0.0078125Z" fill="#2D6E41" />
				<path d="M218.902 286.161C282.415 286.161 333.902 234.674 333.902 171.161C333.902 107.648 282.415 56.1611 218.902 56.1611C155.389 56.1611 103.902 107.648 103.902 171.161C103.902 234.674 155.389 286.161 218.902 286.161Z" fill="#F40B32" />
			</g>
			<defs>
				<clipPath id="clip0_301_1579">
					<rect width="513" height="342" fill="white" transform="translate(0 -0.00585938)" />
				</clipPath>
			</defs>
		</svg>

	);
}